import classes from "../EventApp.module.css";
import Button from "../../../components/UI/Button/Button";
import instance from "../../../store/AxiosInterceptor";
import { useLoaderData, useNavigate } from "react-router-dom";

function EventAppDetail() {
    const resData = useLoaderData();

    const navigate = useNavigate();
    const backHandler = () => {
        navigate("/event/ongoing");
    };

    const navigateHandler = (key) => {
        if(key == null || key === "null") return;
        navigate(`/event/ongoing/${key}`);
    }

    return (
        <>
            <div className={classes.contents_wrap}>
                <div className={classes.view_content}>
                    <div className={classes.title}>
                        <h3>{resData.cur_event_title}</h3>
                        <p className={classes.date}>
                            {resData.cur_event_start_date} ~ {resData.cur_event_end_date}
                        </p>
                    </div>
                    <div className={classes.content}>
                        <div className={classes.img_box}>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: resData.cur_description,
                                }}
                            />
                        </div>
                    </div>
                    <ul className={classes.list_wrap}>
                        <li className={classes.prev} onClick={()=>navigateHandler(`${resData.prev_event_id}`)}>
                            <i>이전글</i>
                            <span>{resData.prev_event_title ? resData.prev_event_title : ""}</span>
                            {resData.prev_event_start_date && resData.prev_event_end_date ? (
                                <em>
                                    {resData.prev_event_start_date} ~ {resData.prev_event_end_date}
                                </em>
                            ) : (
                                <em></em>
                            )}
                        </li>
                        <li className={classes.next} onClick={()=>navigateHandler(`${resData.next_event_id}`)}>
                            <i>다음글</i>
                            <span>{resData.next_event_title ? resData.next_event_title : ""}</span>
                            {resData.next_event_start_date && resData.next_event_end_date ? (
                                <em>
                                    {resData.next_event_start_date} ~ {resData.next_event_end_date}
                                </em>
                            ) : (
                                <em></em>
                            )}
                        </li>
                    </ul>
                    <div className={classes.btn_wrap}>
                        <Button onClick={backHandler}>목록으로</Button>
                    </div>
                </div>
            </div>
        </>
    );
}
export default EventAppDetail;

//이벤트 상세내용 가져오기
export const loader = async ({ params }) => {
    const response = await instance({
        method: "GET",
        url: `/api/v1/home/event/${params.eventId}`,
    }).catch(function (error) {
        if (error.response) {
            return error.response;
        } else if (error.request) {
            return null;
        } else {
            return null;
        }
    });
    if (response == null || response.status !== 200) {
        return [];
    }
    if (response.data.status === 200) {
        return response.data;
    } else {
        return [];
    }
};

//이벤트 상세내용 가져오기
